export default "__VITE_ASSET__CdlPH8xi__"